import React, { useEffect, useState } from 'react';

export default function Areas(props) {
    const [identification, setIdentification] = useState('');
    const [names, setNames] = useState('');
    const [lastName, setLastName] = useState('');
    const [direction, setDirection] = useState('');
    const [phone, setPhone] = useState('');
    const [cellPhone, setCellPhone] = useState('');
    const [email, setEmail] = useState('');
    const [user, setUser] = useState('');
    const [status, setStatus] = useState('')
    useEffect(() => {
        if (props.formData.length > 0) {
            const datForm = props.formData[0];
            setIdentification(datForm["identification"]);
            setNames(datForm["names"]);
            setLastName(datForm["middleNames"]);
            setDirection(datForm["direction"]);
            setPhone(datForm["phone"]);
            setCellPhone(datForm["cellphone"]);
            setEmail(datForm["email"]);
            setUser(datForm["userName"]);
            setStatus(datForm["status"]);
        } else {
            setIdentification(localStorage.getItem("identification"));
            setNames(localStorage.getItem("names"));
            setLastName(localStorage.getItem("middleNames"));
            setDirection(localStorage.getItem("direction"));
            setPhone(localStorage.getItem("phone"));
            setCellPhone(localStorage.getItem("cellphone"));
            setEmail(localStorage.getItem("email"));
            setUser(localStorage.getItem("userName"));
        }
    }, [props]);
    return (
        <>
            <div className="row">
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Identifiación</label>
                                {
                                    props.formData.length === 0
                                        ? <input type="text"
                                            id="identification"
                                            name="identification"
                                            maxLength={10}
                                            value={identification} onChange={e => {
                                                setIdentification(e.target.value.replace(/\D/g, ''))
                                                localStorage.setItem('identification', e.target.value.replace(/\D/g, ''));
                                            }}
                                            className="form-control"
                                            placeholder="Ingresar Areas"
                                        />
                                        : <input type="text"
                                            id="identification"
                                            name="identification"
                                            maxLength={10}
                                            value={identification} onChange={e => {
                                                setIdentification(e.target.value.replace(/\D/g, ''))
                                                localStorage.setItem('identification', e.target.value.replace(/\D/g, ''));
                                            }}
                                            className="form-control"
                                            placeholder="Ingresar código"
                                            disabled />
                                }
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Nombres</label>
                                <input id="names"
                                    name="names"
                                    type="text"
                                    maxLength={20}
                                    value={names}
                                    onChange={e => {
                                        setNames(e.target.value.replace(/[^a-z\s]/gi, ''))
                                        localStorage.setItem('names', e.target.value.replace(/[^a-z\s]/gi, ''));
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar nombres" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Apellidos</label>
                                <input id="lastName"
                                    name="lastName"
                                    type="text"
                                    maxLength={20}
                                    value={lastName}
                                    onChange={e => {
                                        setLastName(e.target.value.replace(/[^a-z\s]/gi, ''))
                                        localStorage.setItem('middleNames', e.target.value.replace(/[^a-z\s]/gi, ''));
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar apellidos" />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Dirección</label>
                                <input id="direction"
                                    name="direction"
                                    maxLength={100}
                                    type="text"
                                    value={direction}
                                    onChange={e => {
                                        setDirection(e.target.value)
                                        localStorage.setItem('direction', e.target.value);
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar dirección" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Teléfono</label>
                                <input id="phone"
                                    name="phone"
                                    maxLength={10}
                                    type="text"
                                    value={phone}
                                    onChange={e => {
                                        setPhone(e.target.value.replace(/\D/g, ''))
                                        localStorage.setItem('phone', e.target.value.replace(/\D/g, ''));
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar teléfono" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Celular</label>
                                <input id="cellPhone"
                                    name="cellPhone"
                                    maxLength={10}
                                    type="text"
                                    value={cellPhone}
                                    onChange={e => {
                                        setCellPhone(e.target.value.replace(/\D/g, ''))
                                        localStorage.setItem('cellphone', e.target.value.replace(/\D/g, ''));
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar celular" />
                            </div>
                        </div>
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label>Correo</label>
                                <input id="email"
                                    name="email"
                                    type="text"
                                    maxLength={100}
                                    value={email}
                                    onChange={e => {
                                        setEmail(e.target.value)
                                        localStorage.setItem('email', e.target.value);
                                    }}
                                    className="form-control"
                                    placeholder="Ingresar correo" />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Usuario</label>
                                {
                                    props.formData.length === 0
                                        ? <input id="user"
                                            name="user"
                                            type="text"
                                            value={user}
                                            maxLength={10}
                                            onChange={e => {
                                                setUser(e.target.value)
                                                localStorage.setItem('userName', e.target.value);
                                            }}
                                            className="form-control"
                                            placeholder="Ingresar un usuario"
                                        />
                                        : <input id="user"
                                            name="user"
                                            type="text"
                                            maxLength={10}
                                            value={user}
                                            onChange={e => {
                                                setUser(e.target.value)
                                                localStorage.setItem('userName', e.target.value);
                                            }}
                                            className="form-control"
                                            placeholder="Ingresar usuario"
                                            disabled />
                                }
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <label>Estado</label>
                                <div className="custom-control custom-switch">
                                    {
                                        status === "Activo"
                                            ?
                                            <input type="checkbox" onChange={e => setStatus(e.target.value)} checked className="custom-control-input" id="statusSiwtch" />
                                            :
                                            <input type="checkbox" onChange={e => setStatus(e.target.value)} className="custom-control-input" id="statusSiwtch" />

                                    }

                                    <label className="custom-control-label" htmlFor="statusSiwtch">{status}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}
